export default "__VITE_ASSET__Duls$hgj__"